const getFirstErrorMessage = errors => errors[0] || null;

export default {
  getFirstErrorMessage,
};
